export default __webpack_public_path__ + "static/media/birthday.73ee147e.svg";